module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-fototeca-scheda-volo",
      "title": "Scheda Volo"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5887769c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/FototecaSchedaVolo.vue
// module id = 873
// module chunks = 39